import {Component, Input} from '@angular/core';
import {Message} from '../../../contracts/message.interface';
import {DatePipe} from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-message-video',
  imports: [DatePipe],
  templateUrl: './message-video.component.html',
  styleUrl: './message-video.component.scss'
})
export class MessageVideoComponent {
  @Input() message!: Message;

  get messageDateFormat(): string {
    const d = new Date(this.message?.creationDate as string | number | Date);
    if (!this.message?.creationDate || isNaN(d.getTime())) return 'HH:mm';
    const today = new Date();
    return d.getFullYear() === today.getFullYear() &&
           d.getMonth() === today.getMonth() &&
           d.getDate() === today.getDate() ? 'HH:mm' : 'dd/MM/yyyy HH:mm';
  }
}
